import * as React from 'react';

import { getGroupedRules } from '../utils';

import { RuleLogicSummary } from './RuleLogicSummary';
import { RuleOutcomeSummary } from './RuleOutcomeSummary';

interface RuleSummaryProps {
  question: ScreenerField;
  questions: ScreenerField[];
}

export const RuleSummary: React.FC<RuleSummaryProps> = ({ question, questions }) => {
  if (!question.answer_tag_logic) {
    return null;
  }

  const rules = getGroupedRules(question.answer_tag_logic);

  return (
    <div className='space-y-4'>
      {rules.map((rule, index) => {
        const sortedOutcomes = [...rule.outcomes].sort((a, b) =>
          a.tag_type === 'skip_to' ? 1 : b.tag_type === 'skip_to' ? -1 : 0
        );

        const [firstOutcome, secondOutcome] = sortedOutcomes;

        return (
          <div key={index} className='space-y-4 rounded-lg bg-gray-50 p-3 text-xs'>
            <div className='flex space-x-2'>
              <RuleLogicSummary question={question} logic={rule.logic} />

              <div className='flex items-center space-x-2'>
                <strong>Then</strong>
                <RuleOutcomeSummary questions={questions} outcome={firstOutcome} />
              </div>
            </div>

            {secondOutcome && (
              <div className='flex items-center space-x-2'>
                <strong>And</strong>
                <RuleOutcomeSummary questions={questions} outcome={secondOutcome} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
